export default {
  setDueDiligenceExemptions (state, dueDiligenceExemptions) {
    state.dueDiligenceExemptions = dueDiligenceExemptions
  },

  setDueDiligenceExemptionsLoading (state, loading) {
    state.loading = loading
  },

  addDueDiligenceExemption (state, dueDiligenceExemption) {
    state.dueDiligenceExemptions.push(dueDiligenceExemption)
  },

  removeDueDiligenceExemption (state, dueDiligenceExemptionId) {
    state.dueDiligenceExemptions = state.dueDiligenceExemptions.filter(e => e.dueDiligenceExemptionId !== dueDiligenceExemptionId)
  },

  updateDueDiligenceExemption (state, dueDiligenceExemption) {
    const index = state.dueDiligenceExemptions.findIndex(e => e.dueDiligenceExemptionId === dueDiligenceExemption.dueDiligenceExemptionId)
    if (index !== -1) {
      Object.assign(state.dueDiligenceExemptions[index], dueDiligenceExemption)
    }
  },

  clearAutoAssignExcept (state, dueDiligenceExemptionId) {
    state.dueDiligenceExemptions.forEach(exemption => {
      if (exemption.dueDiligenceExemptionId !== dueDiligenceExemptionId && exemption.autoAssignWhenNoHits) {
        exemption.autoAssignWhenNoHits = false
      }
    })
  }
}
